module.exports = __webpack_public_path__ + "img/bt-shopping.38d96517.png";